import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class DataMapsTableHeader extends Component
{
  static Layout = [
      { column: "name", width: 2 },
      { column: "description", width: 3 },
      { column: "mapsource" , width: 3 },
      {}
    
  ];

  render() {
      return (
          <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={DataMapsTableHeader.Layout}/>
      )
  }
}